import $ from 'jquery';
import 'jqueryui';

export default async () => {
  window.jQuery = $;
  window.$ = $;
};
